import resumePDF from "../assets/Ebin_Benny_Resume.pdf";
import { motion } from "framer-motion";

export default function Resume() {
  const skills = [
    "HTML",
    "CSS",
    "JavaScript",
    "PHP",
    "Laravel",
    "MySQL",
    "React",
    "Tailwind CSS",
    "REST APIs",
    "Node.js",
    
    "Kotlin",
    "Swift",
    "Git & GitHub",
    
  ];

  return (
    <section
      id="resume"
      className="relative min-h-screen py-24 px-4 bg-black text-white overflow-hidden"
    >
      {/* Floating gradient blobs */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-green-500/20 rounded-full blur-3xl animate-pulse" />
      <div className="absolute bottom-20 right-10 w-72 h-72 bg-blue-500/20 rounded-full blur-3xl animate-pulse" />

      <div className="relative container mx-auto max-w-5xl">
        {/* Section Title */}
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-4xl font-bold mb-6 text-center bg-clip-text text-transparent bg-gradient-to-r from-green-400 to-blue-500"
        >
          Resume
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="text-center text-gray-300 max-w-2xl mx-auto mb-12"
        >
          A quick snapshot of my background, skills, and experience.
          Download my resume for complete details.
        </motion.p>

        {/* Glass Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">

          {/* Education */}
          <motion.div
            whileHover={{ scale: 1.03 }}
            className="backdrop-blur-xl bg-white/5 border border-white/10 rounded-xl p-6 shadow-lg"
          >
            <h3 className="text-xl font-semibold text-green-400 mb-3">
              Education
            </h3>
            <ul className="text-gray-300 space-y-2">
              <li>• Bachelor’s Degree in Computer Science</li>
              <li>• Master’s Degree in Information Technology</li>
              <li>• Strong foundation in programming & problem-solving</li>
            </ul>
          </motion.div>

          {/* Experience */}
          <motion.div
            whileHover={{ scale: 1.03 }}
            className="backdrop-blur-xl bg-white/5 border border-white/10 rounded-xl p-6 shadow-lg"
          >
            <h3 className="text-xl font-semibold text-green-400 mb-3">
              Experience
            </h3>
            <ul className="text-gray-300 space-y-2">
              <li>• Full-stack web development using Laravel & React</li>
              <li>• Backend and mobile development using Kotlin & Swift</li>
              <li>• Built dashboards, APIs, and dynamic websites</li>
            </ul>
          </motion.div>

          {/* Projects */}
          {/* <motion.div
            whileHover={{ scale: 1.03 }}
            className="backdrop-blur-xl bg-white/5 border border-white/10 rounded-xl p-6 shadow-lg"
          >
            <h3 className="text-xl font-semibold text-green-400 mb-3">
              Projects
            </h3>
            <ul className="text-gray-300 space-y-2">
              <li>• Travel Management System</li>
              <li>• ERP Software</li>
              <li>• E-commerce System</li>
              <li>• E-Learning Website</li>
            </ul>
          </motion.div> */}

          {/* Skills */}
          <motion.div
            whileHover={{ scale: 1.03 }}
            className="backdrop-blur-xl bg-white/5 border border-white/10 rounded-xl p-6 shadow-lg"
          >
            <h3 className="text-xl font-semibold text-green-400 mb-4">
              Core Skills
            </h3>
            <div className="flex flex-wrap gap-2">
              {skills.map((skill, i) => (
                <span
                  key={i}
                  className="px-3 py-1 text-sm rounded-full bg-green-500/10 text-green-400 border border-green-500/20"
                >
                  {skill}
                </span>
              ))}
            </div>
          </motion.div>
        </div>

        {/* Resume Download */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 }}
          className="text-center"
        >
          <a
            href={resumePDF}
            download
            className="inline-block px-8 py-4 bg-gradient-to-r from-green-400 to-blue-500 text-black font-semibold rounded-xl shadow-lg hover:scale-105 transition-transform"
          >
            Download Resume (PDF)
          </a>
        </motion.div>
      </div>
    </section>
  );
}
